module.exports = __webpack_public_path__ + "img/22_35.6ea0b976.png";